import { Box, Button } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import React, { useState } from 'react';

import LoadingContainer from '../../../../../components/LoadingContainer';
import { api } from '../../../../../core/api';
import { SearchSummaryDataTable } from '../../../../FinancialData/Companies/SearchSummaryTable';
import { useBenchmarkDispatch, useBenchmarkState } from '../../../Context/BenchmarkContext';
import { BenchmarkContextActionTypes } from '../../../Context/BenchmarkContext.types';
import { TabNamesEnum } from '../BenchmarkTabs';

const SummaryInfo: React.FC = () => {
  const { activeBenchmark, isLoading } = useBenchmarkState();
  const dispatch = useBenchmarkDispatch();
  const [isRefinementLoading, setIsRefinementLoading] = useState(false);

  const handleRefinementClick = async () => {
    setIsRefinementLoading(true);
    try {
      if (activeBenchmark?.id && activeBenchmark?.searchId) {
        await api.benchmark.updateRefinementSearchId(activeBenchmark.id, {
          refinementSearchId: activeBenchmark.searchId,
        });
        const response = await api.benchmark.fetchBenchmarkDetails(activeBenchmark.id);
        if (response) {
          dispatch({
            type: BenchmarkContextActionTypes.SetActiveBenchmark,
            payload: response,
          });
          dispatch({
            type: BenchmarkContextActionTypes.SetClickedBenchmarkTabName,
            payload: TabNamesEnum.REFINEMENT,
          });
        }
      }
    } catch (error) {
      console.error('Error during refinement:', error);
    } finally {
      setIsRefinementLoading(false);
    }
  };

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100%">
        <LoadingContainer size={30} />
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" height="100%" p={2}>
      {/* Header Section */}
      <Box display="flex" justifyContent="flex-end" alignItems="center" mb={2}>
        <Box>
          {isRefinementLoading ? (
            <LoadingContainer size={20} />
          ) : (
            <Button
              onClick={handleRefinementClick}
              variant="contained"
              color="primary"
              startIcon={<EditIcon />}
              disabled={!!activeBenchmark?.refinementSearchId}
            >
              {activeBenchmark?.refinementSearchId ? 'Refinement In Progress' : 'Start Refinement'}
            </Button>
          )}
        </Box>
      </Box>

      {/* Data Table Section */}
      <Box flexGrow={1} overflow="auto">
        <SearchSummaryDataTable data={activeBenchmark?.searchCriteria || []} />
      </Box>
    </Box>
  );
};

export default SummaryInfo;
